export default __webpack_public_path__ + "static/media/guia_aspirante.820ca54a.pdf";